import { DateTimePicker, DateTimePickerProps } from '@progress/kendo-react-dateinputs'
import { Error } from '@progress/kendo-react-labels'
import { useEffect } from 'react'

import { useOcorrenciaStore } from '../../../stores/ocorrencias'

import type { FieldRenderProps } from '@progress/kendo-react-form'

export default function ValidatedIdentificacaoDateTimePicker(fieldRenderProps: FieldRenderProps) {
  const addIdentificacaoTabValidatedField = useOcorrenciaStore(state => state.addIdentificacaoTabValidatedField)
  
  useEffect(() => {
    addIdentificacaoTabValidatedField({ [fieldRenderProps.name]: !!fieldRenderProps.value })
  }, [fieldRenderProps.value])

  return (
    <div>
      <DateTimePicker {...fieldRenderProps as DateTimePickerProps} />
      {fieldRenderProps.visited && fieldRenderProps.validationMessage && <Error>{fieldRenderProps.validationMessage}</Error>}
    </div>
  )
}
